export const rentalContractInfo = {
  intro:
    "Esta informacion sirve como guia general para revisar el contrato de renta antes de avanzar. Las condiciones finales pueden variar segun el local, el propietario y los acuerdos entre las partes.",
  points: [
    "Revisar duracion del contrato, monto de renta, deposito y fechas de pago.",
    "Confirmar si la renta incluye servicios, mantenimiento, IVA u otros cargos.",
    "Definir por escrito quien cubre adecuaciones, reparaciones y permisos del negocio.",
    "Guardar copia firmada del contrato y de los documentos entregados.",
  ],
  cfeNote:
    "Si el local no cuenta con medidor y CFE solicita contrato notariado para realizar el tramite, ese documento puede generar un costo adicional.",
  fullContractUrl: "/contrato-renta-comercial-base.html",
};
